var _rect, _rect2, _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgDeleteIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 24,
    height: 24,
    rx: 4,
    fill: "#F1F1F1"
  })), /*#__PURE__*/React.createElement("mask", {
    id: "mask0_403_28374",
    style: {
      maskType: "alpha"
    },
    maskUnits: "userSpaceOnUse",
    x: 5,
    y: 5,
    width: 14,
    height: 14
  }, _rect2 || (_rect2 = /*#__PURE__*/React.createElement("rect", {
    x: 5,
    y: 5,
    width: 14,
    height: 14,
    fill: "#D9D9D9"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask0_403_28374)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M9.08301 17.25C8.76217 17.25 8.48752 17.1358 8.25905 16.9073C8.03058 16.6788 7.91634 16.4042 7.91634 16.0833V8.5H7.33301V7.33333H10.2497V6.75H13.7497V7.33333H16.6663V8.5H16.083V16.0833C16.083 16.4042 15.9688 16.6788 15.7403 16.9073C15.5118 17.1358 15.2372 17.25 14.9163 17.25H9.08301ZM14.9163 8.5H9.08301V16.0833H14.9163V8.5ZM10.2497 14.9167H11.4163V9.66667H10.2497V14.9167ZM12.583 14.9167H13.7497V9.66667H12.583V14.9167Z",
    fill: "#F14445"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgDeleteIcon);
export default __webpack_public_path__ + "static/media/delete-icon.6f0673c86f527626875dc9a4cb6889f7.svg";
export { ForwardRef as ReactComponent };